import React from 'react';

interface ISvgIcon {
  color?: string;
}

const Share = ({color = "#FFF"} : ISvgIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.4" height="14.598" viewBox="0 0 12.4 14.598">
      <g id="menu" transform="translate(0.2 0.2)">
        <g id="Group_715" data-name="Group 715">
          <g id="Group_714" data-name="Group 714">
            <path id="Path_3624" data-name="Path 3624" d="M9.766,0H2.234A2.468,2.468,0,0,0,0,2.644v8.91A2.468,2.468,0,0,0,2.234,14.2H9.766A2.468,2.468,0,0,0,12,11.554V2.644A2.468,2.468,0,0,0,9.766,0ZM11.3,11.554a1.691,1.691,0,0,1-1.531,1.812H2.234A1.691,1.691,0,0,1,.7,11.554V2.644A1.691,1.691,0,0,1,2.234.832H9.766A1.691,1.691,0,0,1,11.3,2.644Z" fill={color} stroke={color} strokeWidth="0.4"/>
          </g>
        </g>
        <g id="Group_717" data-name="Group 717" transform="translate(2.259 3.374)">
          <g id="Group_716" data-name="Group 716">
            <path id="Path_3625" data-name="Path 3625" d="M103.53,120.5H96.752a.352.352,0,0,0,0,.7h6.778a.352.352,0,0,0,0-.7Z" transform="translate(-96.4 -120.5)" fill={color} stroke={color} strokeWidth="0.4"/>
          </g>
        </g>
        <g id="Group_719" data-name="Group 719" transform="translate(2.259 6.747)">
          <g id="Group_718" data-name="Group 718">
            <path id="Path_3626" data-name="Path 3626" d="M103.53,241H96.752a.352.352,0,1,0,0,.7h6.778a.352.352,0,1,0,0-.7Z" transform="translate(-96.4 -241)" fill={color} stroke={color} strokeWidth="0.4"/>
          </g>
        </g>
        <g id="Group_721" data-name="Group 721" transform="translate(2.259 10.121)">
          <g id="Group_720" data-name="Group 720">
            <path id="Path_3627" data-name="Path 3627" d="M103.53,361.5H96.752a.352.352,0,0,0,0,.7h6.778a.352.352,0,1,0,0-.7Z" transform="translate(-96.4 -361.5)" fill={color} stroke={color} strokeWidth="0.4"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Share;